export default "assets/e016b7b0ddbe31a530b2b1af87217f80.png";